// src/components/scratch/ScratchTierBadge.jsx
import React from "react";
import Icon from "../ui/Icon";

/**
 * Small pill displayed on the Scratch dashboard header so the user can see
 * what they're entitled to at a glance.
 *
 * Style varies by tier; all language is neutral ("active subscription"),
 * never promotional ("you're winning!").
 */
export default function ScratchTierBadge({ tier }) {
  if (!tier || tier === "NONE") return null;

  const config = {
    PLUS:  { label: "Plus",  color: "var(--teal)", bg: "var(--teal-dim)",  border: "var(--teal-border)" },
    PRO:   { label: "Pro",   color: "var(--gold)", bg: "var(--gold-dim)",  border: "var(--gold-border)" },
    ELITE: { label: "Elite", color: "var(--ink)",  bg: "var(--ink-dim)",   border: "var(--ink-border)"  },
  }[tier];

  if (!config) return null;

  return (
    <span
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold tracking-wide"
      style={{
        background: config.bg,
        color: config.color,
        border: `1px solid ${config.border}`,
      }}
      title={`Your active scratch-off tier: ${config.label}`}
    >
      <Icon name="shield-check" size={11} />
      {config.label}
    </span>
  );
}
